import { render, staticRenderFns } from "./addIndustry.vue?vue&type=template&id=5f3045c8&scoped=true&"
import script from "./addIndustry.vue?vue&type=script&lang=js&"
export * from "./addIndustry.vue?vue&type=script&lang=js&"
import style0 from "./addIndustry.vue?vue&type=style&index=0&id=5f3045c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3045c8",
  null
  
)

export default component.exports